(function () {
    'use strict';

    angular
        .module('app')
        .controller('SMSComposeCtrl', SMSComposeCtrl);

    SMSComposeCtrl.$inject = [
        '$q',
        '$routeParams',
        '$scope',
        'EntitiesService',
        'SMSTemplatesService',
        'TagsService',
        'DialogService',
        'NavigationAidService',
        'WindowTitleService',
        'SMS',
        'UnsavedChangesService'];

    /**
     * @ngdoc control
     * @name SMSComposeCtrl
     * 
     * @description
     * Controller which is used to compose SMS messages.
     */
    function SMSComposeCtrl(
        $q,
        $routeParams,
        $scope,
        EntitiesService,
        SMSTemplatesService,
        TagsService,
        DialogService,
        NavigationAidService,
        WindowTitleService,
        SMS,
        UnsavedChangesService) {

        /* jshint validthis:true */
        var vm = this;
        vm.tags = {};

        vm.errorMessage = null;
        vm.sendInProgress = false;
        vm.loading = true;
        vm.sms = { To: [], Message: '' };
        vm.setSMSTemplate = setSMSTemplate;
        vm.sendButtonClicked = sendButtonClicked;
        vm.showSMSPreview = showSMSPreview;
        vm.showSelectRecipients = showSelectRecipients;
        vm.close = close;

        activate();

        function activate() {
            var loadPromise = $q.when(null);

            loadTags();

            WindowTitleService.setTitle(vm.viewTitle);

            // Either fromEntityIds or copySMSId must be provided. Only one of these can be provided otherwise the view will be in an error state.
            if ((angular.isDefined($routeParams.fromEntityIds) && $routeParams.fromEntityIds !== null && $routeParams.fromEntityIds !== '') &&
               (angular.isDefined($routeParams.copySMSId) && $routeParams.copySMSId !== null && $routeParams.copySMSId !== '')) {
                vm.errorMessage = 'Either a list of entities from which the SMS are to be sent or the id of an existing SMS to copy must be provided. Both of these cannot be provided.';
            } else if ((angular.isDefined($routeParams.fromEntityIds) && $routeParams.fromEntityIds !== null && $routeParams.fromEntityIds !== '') ||
                   (angular.isDefined($routeParams.copySMSId) && $routeParams.copySMSId !== null && $routeParams.copySMSId !== '')) {
                loadPromise = createSMS($routeParams.fromEntityIds, $routeParams.copySMSId);
            } else {
                vm.errorMessage = 'Either a list of entities from which the SMS are to be sent or the id of an existing SMS to copy must be provided.';
            }

            return loadPromise
                .then(loadSMSTemplates)
                .then(loadSMSContacts)
                .finally(function () {
                    vm.loading = false;

                    UnsavedChangesService.register({
                        scope: $scope,
                        modelExpression: 'vm.sms',
                        onLocationChange: dirtyObjectPrompt,
                        unsavedItemName: 'SMS'
                    });
                });
        }

        function dirtyObjectPrompt() {
            if (!UnsavedChangesService.skipDirtyCheck && UnsavedChangesService.dirty) {
                return DialogService.unsavedChanges('SMS', true, '<p>The SMS has not been sent.</p><p>Do you wish to send the SMS?</p>')
                    .then(function (SMSToBeSent) {
                        if (SMSToBeSent) {
                            return sendSMS();
                        }
                    });
            }
        }

        /**
         * Creates a new SMS message
         */
        function createSMS(fromEntityIds, copySMSId) {
            var createSMSPromise = {};

            if (!_.isNil(fromEntityIds)) {
                createSMSPromise = SMS.getNew(fromEntityIds)
                    .then(createSMSOk, createSMSError);
            } else {
                createSMSPromise = SMS.copySMS(copySMSId)
                    .then(createSMSOk, createSMSError);
            }

            function createSMSOk(data) {
                vm.sms = data;

                if (vm.sms.data.MultipleFromMode)
                    vm.viewTitle = 'Create Bulk SMS';
                else
                    vm.viewTitle = 'Create SMS';

            }

            function createSMSError(response) {
                vm.error = response;
            }

            return createSMSPromise;
        }

        /**
         * Load the sms templates associated with the SMS.
         *
         * @returns {promise}
         */
        function loadSMSTemplates() {
            if (!_.isNil(vm.sms.primaryEntityId)) {
                return EntitiesService.get(vm.sms.primaryEntityId)
                    .then(function (entity) {
                        return SMSTemplatesService.query({ entityTemplateId: entity.EntityTemplate.Id, active: true })
                            .then(function (smsTemplates) {
                                vm.smsTemplates = smsTemplates.Items;
                            });
                    });
            } else {
                $q.resolve();
            }
        }

        /**
         * Load the contacts associated with the SMS.
         *
         * @returns {promise}
         */
        function loadSMSContacts() {
            if (!_.isNil(vm.sms.primaryEntityId)) {
                return EntitiesService.getContacts(vm.sms.primaryEntityId, true, ['SMS'])
                    .then(function (contacts) {
                        // When in Multiple From Mode, only field reference contacts should be used
                        if (vm.sms.data.MultipleFromMode) {
                            vm.smsContacts = _.filter(contacts, function (contact) {
                                return contact.ReferenceContact;
                            });
                        } else {
                            vm.smsContacts = _.filter(contacts, function (contact) {
                                return !contact.ReferenceContact;
                            });
                        }
                    });
            } else {
                $q.resolve();
            }
        }

        /**
         * Load tags into the vm.tags variable.
         *
         * @returns {promise} A promise that resolves once the tags are loaded, or an error occurred.
         */
        function loadTags() {
            return TagsService.query({ tagUsage: 'SMS' })
                .then(getTagsOk, getTagsError);

            function getTagsOk(data) {
                vm.tags = data.Tags;
            }

            function getTagsError(response) {
                DialogService.error('Error fetching Tags', response);
            }
        }

        /**
         * Sends the SMS and if the send process resolves without rejection, the user will be navigated to their previous view.
         */
        function sendButtonClicked() {
            return sendSMS()
                .then(function () {
                    NavigationAidService.goBack();
                });
        }

        /**
         * Sends the SMS message
         */
        function sendSMS() {
            if (!_.isNil(vm.sms.validateSMS) && vm.sms.validateSMS.length > 0) {
                return DialogService.messageList('Error sending SMS', vm.sms.validateSMS)
                    .finally(function () {
                        return $q.reject();
                });
            } else {
                vm.sendInProgress = true;
                var sendRequest = {};

                if (vm.sms.data.MultipleFromMode) {
                    sendRequest = showSelectRecipients()
                        .then(function (sendRecipients) {
                            return vm.sms.send(sendRecipients)
                                .then(sendSMSOk, sendSMSError);
                        });
                } else {
                    sendRequest = vm.sms.send()
                            .then(sendSMSOk, sendSMSError);
                }

                return sendRequest.finally(function () {
                    vm.sendInProgress = false;
                });
            }

            function sendSMSOk(response) {
                UnsavedChangesService.dirty = false;
                showSendReport(response);
            }

            function sendSMSError(response) {
                return DialogService.error('Error sending SMS.', response)
                    .finally(function () {
                        return $q.reject();
                    });
            }
        }

        /**
         * Opens a dialog showing a send report for the SMS.
         */
        function showSendReport(sendReports) {
            return DialogService.show({
                controller: 'SendReportDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/controls/dialog/send-report-dialog.tmpl.html',
                locals: { sendReports: sendReports, reportType: 'SMS' },
                size: DialogService.sizes.extraLarge
            });
        }

        /**
         * Opens a dialog showing a recipients selector for the SMS.
         *
         * @param {bool} viewOnlyMode - Should the dialog be shown in view only mode
         */
        function showSelectRecipients(viewOnlyMode) {
            return DialogService.show({
                controller: 'SMSSelectRecipientsDialogCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'app/sms/sms-select-recipients-dialog.tmpl.html',
                    locals: { sms: vm.sms, viewOnlyMode: viewOnlyMode },
                size: DialogService.sizes.large
            });
        }

        /**
         * Opens set SMS template dialog for the SMS.
         */
        function setSMSTemplate() {
            DialogService.show({
                controller: 'SetSMSTemplateDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/sms/set-sms-template-dialog.tmpl.html',
                locals: {
                    sms: vm.sms,
                    smsTemplates: vm.smsTemplates
                }
            });
        }

        /**
         * Opens a dialog showing a 'preview' of the SMS. This is how the sent SMS would look.
         */
        function showSMSPreview() {
            DialogService.show({
                controller: 'SmsViewDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/sms/sms-view-dialog.tmpl.html',
                locals: { sms: vm.sms },
                size: DialogService.sizes.extraLarge
            });
        }

        /**
         * Navigate to the previous page
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();
